// AboutPage.tsx

import React, { useEffect } from "react";
import aboutImage from "../../assets/immagine_dream.png";
import rocketIcon from "../../assets/rocket.png"; // Replace with your own icon
import { Screens } from "../../shared/types";
import useMediaQuery from "../../hooks/useMediaQuery";

const AboutPage: React.FC = () => {
  const isAboveHugeScreen = useMediaQuery(Screens.Huge);
  const isAboveLargeScreen = useMediaQuery(Screens.Large);
  const isAboveMediumScreen = useMediaQuery(Screens.Medium);
  const isAboveSmallScreens = useMediaQuery(Screens.Small);

  function getHeight(): String {
    if (isAboveHugeScreen) {
      return " mt-whiteSpacingXL";
    } else if (isAboveLargeScreen) {
      return "mt-whiteSpacingM";
    } else if (isAboveMediumScreen || isAboveSmallScreens) {
      return "mt-whiteSpacingXL";
    } else {
      return "mt-whiteSpacingSL";
    }
  }
  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, []); // The empty dependency array ensures this effect runs only once when the component mounts

  return (
    <main
      className={`bg-gray-100 w-full h-full sm:h-full pb-8 2xl:h-full 2xl:py-40 flex flex-col justify-center items-center lg:px-0 px-4`}
    >
      <div className="container mx-auto text-center mb-8">
        <h1 className="2xl:text-7xl lg:text-6xl font-bold text-4xl mt-24 text-center  text-palette1 mb-6 lg:mb-6">
          About Us
        </h1>
        <p className="text-gray-950 lg:text-xl 2xl:text-4xl">
          Discover the Vision Behind Dream Innovation
        </p>
      </div>
      <div
        className={`container  mx-auto p-6 bg-white rounded-lg shadow-lg text-justify `}
      >
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center `}>
          <div>
            <p className="2xl:text-lg lg:text-base text-sm text-black mb-6">
              Dream Innovation is a young Small Enterprise focused on management
              consulting, technology and innovation research development. Dream
              Innovation operates mainly in the aerospace and automotive fields
              both in civil and military applications. Dream was established in
              2013 born on the passion, innovation and cutting-edge worldwide
              expertise of people who dedicated their working lives to the
              high-value technological sectors, such as aerospace, automotive,
              high tech industrial applications and defense by developing deep
              competences in fluid dynamics simulations, advanced mechanical
              design and advanced materials. Dream is a combination of young
              innovators and talented senior partners and old and talented
              seniors who have dedicated their life and passion in research and
              technology development by cumulating a wide-ranging expertise in
              these sectors and that can provide support your business growth
              strategies each step of the way.
            </p>
            <p className="2xl:text-lg text-sm lg:text-base text-black mb-6">
              Dream has worked with many European leading enterprises in the
              research and innovation aerospace sector as well as new
              business/market propositions. Our business growth support services
              can cover business areas such as strategy, advisory and management
              consulting.
            </p>
            <p className="2xl:text-lg text-sm lg:text-base text-black  mb-6">
              Dream has provided support to various companies, universities and
              research centres in the drafting of research proposals to
              participate in public tenders both at European, national and
              regional level, winning many of these calls for proposals.
            </p>
            <p className="2xl:text-lg text-sm lg:text-base text-black">
              You can trust Dream as your preferred partner both if you need
              strategic advice on activities that require high numerical and
              mechanical simulation skills and if you need to develop a
              technological diversification strategy in a different high-value
              manufacturing market.
            </p>
          </div>
          <div className="md:order-first">
            <img
              src={aboutImage}
              alt="About Us"
              className="w-full h-full object-cover rounded-lg shadow-md"
            />
            <div className="flex items-center lg:mt-8 mt-4">
              <img
                src={rocketIcon}
                alt="Rocket Icon"
                className="w-8 h-8 mr-2"
              />
              <span className="text-sm lg:text-base text-black">
                Launching Innovation to New Heights
              </span>
            </div>
          </div>
        </div>
        <div className="2xl:mt-12 mt-4 border-t 2xl:pt-6 pt-4">
          <h2 className="text-2xl font-bold 2xl:mb-4 mb-2 sm:text-justify text-center">
            Our Mission
          </h2>
          <p className="2xl:text-lg lg:text-base text-base text-black ">
            "Our mission is to create Technological Innovation with a real
            impact on society."
          </p>
        </div>
      </div>
    </main>
  );
};

export default AboutPage;
